import React, { useEffect, useRef, useState } from 'react';
import { getStudentAvatar } from '../../shared/studentAvatar';

export function studentPageHref(studentId) {
  const params = new URLSearchParams(window.location.search);
  params.set('student_id', String(studentId));
  return `${window.location.pathname}?${params}${window.location.hash}`;
}

export default function StudentProfileSelector({ students = [], studentId, onStudentChange, children }) {
  const [open, setOpen] = useState(false);
  const trigger = useRef(null);
  const panel = useRef(null);
  const multiple = students.length > 1;
  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    const links = panel.current?.querySelectorAll('a, button');
    links?.[0]?.focus();
    const trap = (event) => {
      if (event.key !== 'Tab' || !links?.length) return;
      const first = links[0];
      const last = links[links.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', close);
    document.addEventListener('keydown', trap);
    return () => { document.removeEventListener('keydown', close); document.removeEventListener('keydown', trap); };
  }, [open]);
  if (!multiple) return children;
  const close = () => { setOpen(false); trigger.current?.focus(); };
  return <>
    <button ref={trigger} className="student-profile-trigger" type="button" aria-label="Öğrenci değiştir"
      aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}>{children}</button>
    {open && <div className="student-selector-backdrop" onClick={close}>
      <div ref={panel} className="student-selector-panel" role="dialog" aria-modal="true" aria-label="Öğrenci seçimi" onClick={(event) => event.stopPropagation()}>
        <div className="student-selector-heading"><strong>Öğrenci seç</strong><button type="button" onClick={close} aria-label="Öğrenci seçimini kapat">✕</button></div>
        {students.map((student) => {
          const sid = String(student.student_id ?? student.id);
          const avatar = getStudentAvatar(sid, student.avatar_id, student.starter_emoji);
          const active = sid === String(studentId);
          const name = `${student.first_name || student.name || ''} ${student.last_name || student.surname || ''}`.trim();
          const className = student.class_name || student.grade || '';
          const content = <><span className="student-selector-avatar" style={{ background: avatar.bgColor }}>
            {avatar.imageUrl ? <img src={avatar.imageUrl} alt="" /> : avatar.avatar}</span>
            <span><strong>{name}</strong>{className && <small>{className}{/sınıf/i.test(className) ? '' : ' Sınıfı'}</small>}</span>
            {active && <span className="student-selector-check" aria-label="Aktif öğrenci">✓</span>}</>;
          const select = (event) => {
            if (active) { event.preventDefault(); close(); }
            else if (onStudentChange) { event.preventDefault(); onStudentChange(sid); close(); }
          };
          return <a key={sid} className="student-selector-option" href={studentPageHref(sid)}
            aria-current={active ? 'true' : undefined} onClick={select}>{content}</a>;
        })}
      </div>
    </div>}
  </>;
}
